import type { MainFeatureStates } from '../mainFeatureStates';
import type { FeatureStates } from '../featureStates';

export function featuresAndSubfeatures(states: MainFeatureStates): FeatureStates {
  const onlyMeetings = (s: MainFeatureStates): boolean => {
    for (const [key, value] of Object.entries(s)) {
      if ((key === 'meetings' && value === false) || (key !== 'meetings' && value === true)) {
        return false;
      }
    }
    return true;
  };

  // TEMPORARY: Treat performanceReview the same as meetings for widget visibility
  // This ensures overview page widgets are shown for PERFORMANCE_REVIEW accounts
  // TODO: Remove this override once the server properly handles PERFORMANCE_REVIEW
  const hasMeetingsOrPerformanceReview = states.meetings || states.performanceReview;

  return {
    ...states,
    pageEmployees: !onlyMeetings(states),
    pagePartners: states.core || states.substances || states.data || (states.meetings && !onlyMeetings(states)),
    pagePeople: onlyMeetings(states),
    pageEvents: states.core || states.hse || hasMeetingsOrPerformanceReview,
    pageManagement: states.core || states.hse || hasMeetingsOrPerformanceReview,
    pageHse: states.core || states.hse || hasMeetingsOrPerformanceReview,
    pageBusiness: states.core || states.hse || hasMeetingsOrPerformanceReview,
    pageAssetManagement: states.core,
    pageInformationSecurity: states.core,
    pageQuality: states.core,
    entityEmployees: true,
    entityEmployeesComplete: states.core || states.hse || states.staffing,
    entityPartners: states.core || states.meetings || states.substances || states.data,
    entityPartnersComplete: states.core || states.data || states.hse,
    entityEvents: states.core || states.hse || hasMeetingsOrPerformanceReview,
    organizationComplete: states.core || states.hse || hasMeetingsOrPerformanceReview,
    video: states.video,
    ask: states.ask,
  };
}
